<template>
  <node-view-wrapper class="vue-component">
    <!-- <span class="label">Custom Component</span> -->
    <div class="content">
      <a class="el-button" :href="node.attrs.url" target="_blank" style="margin-right: 10px; text-decoration: none;">
        {{node.attrs.text}}
      </a>
    </div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper,
  },

  props: nodeViewProps,

  methods: {
  },
};
</script>

<style lang="scss">
.vue-component {
  display: contents;
  background: #FAF594;
  border: 3px solid #0D0D0D;
  // border-radius: 0.5rem;
  margin: 1rem;
  // position: relative;
}

// .label {
//   margin-left: 1rem;
//   background-color: #0D0D0D;
//   font-size: 0.6rem;
//   letter-spacing: 1px;
//   font-weight: bold;
//   text-transform: uppercase;
//   color: #fff;
//   position: absolute;
//   top: 0;
//   padding: 0.25rem 0.75rem;
//   border-radius: 0 0 0.5rem 0.5rem;
// }

.content {
  margin: 10px;
  padding: 1rem;
  // display: contents;
  display: flex;
  justify-content: center;
}
</style>
